// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Caml_option from "../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../../utils/CSS.bs.js";
import * as Unicons$Showside from "../../icons/Unicons.bs.js";
import * as DataAttribute$Showside from "../../utils/DataAttribute.bs.js";
import * as ReactDOMUtils$Showside from "../../utils/ReactDOMUtils.bs.js";
import * as EntrypointContext$Showside from "../../context/EntrypointContext.bs.js";
import * as UseSimulatedClick$Showside from "../../hook/UseSimulatedClick.bs.js";
import * as ConfigurationProvider$Showside from "../../context/ConfigurationProvider.bs.js";
function NavMenu__Hamburger$Item(Props) {
  var category = Props.category;
  var link = Props.link;
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var match$1 = EntrypointContext$Showside.use(undefined);
  var onPureCategoryClick = match$1.onPureCategoryClick;
  var trackEvent = match$1.trackEvent;
  var ref = React.useRef(null);
  var href;
  href = typeof link === "number" || link.TAG === /* InternalLink */0 ? undefined : link._0.href;
  var handleOnClick = function (param) {
    if (typeof link === "number") {
      return Curry._2(onPureCategoryClick, undefined, category);
    } else if (link.TAG === /* InternalLink */0) {
      return Curry._1(link._0, undefined);
    } else {
      return Curry.app(trackEvent, ["menu:link clicked", undefined, category, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
    }
  };
  var match$2 = UseSimulatedClick$Showside.useMouse(undefined, undefined, handleOnClick);
  var target;
  target = typeof link === "number" ? config.settings.openLinkInNewTab ? "_blank" : undefined : link.TAG === /* InternalLink */0 ? config.settings.openLinkInNewTab ? "_blank" : undefined : link._0.openInNewTab ? "_blank" : undefined;
  var tmp;
  tmp = typeof link === "number" || link.TAG === /* InternalLink */0 ? "" : "underline";
  var tmp$1 = {
    ref: ReactDOMUtils$Showside.Ref.domRef(ref),
    className: CSS$Showside.prefix(Cn.make(["outline-none flex items-center select-none", "text-color-unset", "py-6 px-4", "cursor-default", tmp])),
    tabIndex: 0,
    onClick: handleOnClick,
    onMouseDown: match$2.onMouseDown,
    onMouseLeave: match$2.onMouseLeave,
    onMouseUp: match$2.onMouseUp
  };
  if (href !== undefined) {
    tmp$1.href = Caml_option.valFromOption(href);
  }
  if (target !== undefined) {
    tmp$1.target = Caml_option.valFromOption(target);
  }
  var tmp$2;
  var exit = 0;
  if (typeof link === "number" || link.TAG === /* InternalLink */0) {
    exit = 1;
  } else {
    tmp$2 = null;
  }
  if (exit === 1) {
    tmp$2 = React.createElement("div", {
      className: CSS$Showside.prefix("opacity-50")
    }, React.createElement(Unicons$Showside.UilAngleRightB.make, {
      size: /* Px */{
        _0: 18
      }
    }));
  }
  return React.createElement(DataAttribute$Showside.make, {
    dataTestId: "nav-menu-hamburger-item",
    children: React.createElement("li", undefined, React.createElement("a", tmp$1, React.createElement("div", {
      className: CSS$Showside.prefix("flex-grow truncate-lines truncate-lines-1")
    }, category.title), tmp$2))
  });
}
NavMenu__Hamburger$Item.displayName = "NavMenu__Hamburger.Item";
var Item = {
  make: NavMenu__Hamburger$Item
};
function NavMenu__Hamburger(Props) {
  var itemsOpt = Props.items;
  var items = itemsOpt !== undefined ? itemsOpt : [];
  var renderWithDividers = function (els) {
    return Belt_Array.concatMany(Belt_Array.mapWithIndex(els, function (i, e) {
      if (i === 0) {
        return [e];
      } else {
        return [React.createElement("div", {
          key: String(i),
          className: CSS$Showside.prefix("opacity-5 border-t border-current w-full")
        }), e];
      }
    }));
  };
  return React.createElement(DataAttribute$Showside.make, {
    dataTestId: "nav-menu-hamburger",
    children: React.createElement("ul", {
      className: CSS$Showside.prefix(Cn.make(["list-none justify-center", "w-full max-h-full", "overflow-auto", "p-0 m-0"]))
    }, renderWithDividers(Belt_Array.map(Belt_Array.keep(items, function (param) {
      return !param.isHidden;
    }), function (param) {
      var category = param.category;
      return React.createElement(NavMenu__Hamburger$Item, {
        category: category,
        link: param.link,
        key: category.id
      });
    })))
  });
}
NavMenu__Hamburger.displayName = "NavMenu__Hamburger";
var make = NavMenu__Hamburger;
export { Item, make };
/* react Not a pure module */